export const EMAIL = "rayzck9@gmail.com"
export const TWITTER_LINK = "https://twitter.com/rzalkikar"
export const GITHUB_LINK = "https://github.com/zalkikar"